module.exports = __webpack_public_path__ + "media/images/brand/banner/spot_art-f463e947c239bbdf479b6cf08c5df0a8.png";